import { Size } from "@repo/ui/helpers/helpers";
import { SimpleMenu } from "@repo/ui/Menu/simpleMenu";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import { SimpleMenuPopover } from "@repo/ui/Menu/simpleMenuPopover";
import { selectStyle } from "@repo/ui/Select/style";
import { IconSelector } from "@tabler/icons-react";
import type { FC, ReactNode } from "react";
import { Button as AriaButton, DialogTrigger } from "react-aria-components";

const chipStyle = selectStyle({ size: Size.SMALL });

/**
 * Active filter chip: renders `children` as the chip label and a
 * "Remove filter"-only dropdown matching the calls-page pattern.
 */
export const RemoveFilterChip: FC<{
  children: ReactNode;
  onRemove: () => void;
  ariaLabel?: string;
}> = ({ children, onRemove, ariaLabel = "Filter options" }) => (
  <DialogTrigger>
    <AriaButton className={chipStyle.button()}>
      <span className={chipStyle.value({ className: "flex items-center" })}>
        {children}
      </span>
      <IconSelector className={chipStyle.chevron()} />
    </AriaButton>
    <SimpleMenuPopover placement="bottom start">
      <SimpleMenu aria-label={ariaLabel}>
        <SimpleMenuItem onAction={onRemove}>Remove filter</SimpleMenuItem>
      </SimpleMenu>
    </SimpleMenuPopover>
  </DialogTrigger>
);

/**
 * Empty-state filter button: opens `children` in a popover (typically a
 * picker menu). Used by outcome and teammate filters before a value is
 * selected.
 */
export const FilterPlaceholderButton: FC<{
  placeholder: ReactNode;
  children: ReactNode;
}> = ({ placeholder, children }) => (
  <DialogTrigger>
    <AriaButton className={chipStyle.button()}>
      <span className={chipStyle.value()}>{placeholder}</span>
      <IconSelector className={chipStyle.chevron()} />
    </AriaButton>
    <SimpleMenuPopover placement="bottom start">{children}</SimpleMenuPopover>
  </DialogTrigger>
);
